import { Link } from 'react-router-dom';

import styles from './Login.module.scss';
import loginImage from '../assets/images/loginImage.png';
import logoNew from '../assets/images/logoNew.png';

const ResetPasswordPage = () => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.forgotLeftContainer}>
          <img src={logoNew} alt="" />
          <div className={styles.headingContainer}>
            <span className={styles.heading}>Reset Password</span>
            <span className={styles.subHeading}>
              Please enter the verification code we have sent on your gmail
              account
            </span>
          </div>

          <div className={styles.inputContainer}>
            <input type="text" placeholder="Enter new password" />
            <input type="text" placeholder="Reenter new password" />
          </div>
          <Link to="/admin/finishPage" className={styles.primaryBtn}>
            Set Password
          </Link>
        </div>
        <div className={styles.rightContainer}>
          <img src={loginImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
